<template>
  <!-- Change viewBox and fill params -->
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 41 32"
  >
    <g
      :fill="color"
      class="fill-current"
    >
      <path d="M37.713 0h-29.712c-1.894 0-3.429 1.535-3.429 3.429v0 1.144h-1.142c-1.893 0-3.428 1.534-3.429 3.427v20.57c0 1.894 1.535 3.429 3.429 3.429v0h29.712c1.894 0 3.429-1.535 3.429-3.429v0-1.144h1.144c1.894 0 3.429-1.535 3.429-3.429v0-20.568c0-1.894-1.535-3.429-3.429-3.429-0.001 0-0.001 0-0.002 0h0zM34.286 28.571c0 0.632-0.512 1.144-1.144 1.144v0h-29.712c-0.632 0-1.144-0.512-1.144-1.144v0-20.57c0-0.632 0.512-1.144 1.144-1.144v0h1.142v17.143c0 1.894 1.535 3.429 3.429 3.429h26.285zM38.857 24c0 0.632-0.512 1.144-1.144 1.144h-29.712c-0.632 0-1.144-0.512-1.144-1.144v0-20.57c0-0.632 0.512-1.144 1.144-1.144v0h29.712c0.632 0 1.144 0.512 1.144 1.144v0zM12.572 12.001c2.209 0 4-1.791 4-4s-1.791-4-4-4c-2.209 0-4 1.791-4 4v0c0 2.209 1.791 4 4 4v0zM12.572 6.286c0.947 0 1.715 0.768 1.715 1.715s-0.768 1.715-1.715 1.715c-0.947 0-1.715-0.768-1.715-1.715v0c0.001-0.947 0.768-1.714 1.715-1.715h0zM29.784 7.931c-0.31-0.31-0.739-0.502-1.212-0.502s-0.902 0.192-1.212 0.502l-6.787 6.787-2.218-2.216c-0.31-0.31-0.739-0.502-1.212-0.502s-0.902 0.192-1.212 0.502l-6.286 6.286c-0.31 0.31-0.501 0.738-0.501 1.211v2c0 0.473 0.383 0.856 0.856 0.856v0h25.716c0.473 0 0.856-0.383 0.856-0.856v0-6.569c-0-0.473-0.192-0.901-0.502-1.211l0 0zM34.286 20.572h-22.858v-0.336l5.715-5.715 3.429 3.429 8-8 5.715 5.715z" />
    </g>

  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    }
  }
}
</script>
